import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';

import ConsumerPageHeaderBffProvider from 'bundles/composable-page-header-consumer/providers/ConsumerPageHeaderBffProvider';
import ShoppingCartProvider from 'bundles/composable-page-header-consumer/providers/ShoppingCartProvider';

const DefaultConsumerPageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <StatsigProvider>
      <ConsumerPageHeaderBffProvider>
        <ShoppingCartProvider>{children}</ShoppingCartProvider>
      </ConsumerPageHeaderBffProvider>
    </StatsigProvider>
  );
};

export default DefaultConsumerPageHeaderProvider;
